import React from "react";
import { useTheme } from "@mui/material/styles";
import TextEditor from "app/Components/Fields/TextEditor";

interface DescriptionProps {
  description: string;
  handleChange: (value: string) => void;
  placeholder?: string;
}

function Description({
  description,
  handleChange,
  placeholder = "Game Description",
}: DescriptionProps) {
  const theme = useTheme();
  
  return (
    <TextEditor
      text={description}
      handleChange={handleChange}
      placeholder={placeholder}
      backgroundColor={theme.palette.background.paper}
    />
  );
}

export default Description;
